/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ReleaseFamilyPaymentRequest
 */
export interface ReleaseFamilyPaymentRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ReleaseFamilyPaymentRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ReleaseFamilyPaymentRequest
     */
    userVaultId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ReleaseFamilyPaymentRequest
     */
    currency: string;
    /**
     * 
     * @type {Date}
     * @memberof ReleaseFamilyPaymentRequest
     */
    currencyDate: Date;
    /**
     * 
     * @type {number}
     * @memberof ReleaseFamilyPaymentRequest
     */
    totalAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseFamilyPaymentRequest
     */
    note: string | null;
    /**
     * 
     * @type {Origin}
     * @memberof ReleaseFamilyPaymentRequest
     */
    origin: Origin;
}



/**
 * Check if a given object implements the ReleaseFamilyPaymentRequest interface.
 */
export function instanceOfReleaseFamilyPaymentRequest(value: object): value is ReleaseFamilyPaymentRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userVaultId' in value) || value['userVaultId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('currencyDate' in value) || value['currencyDate'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function ReleaseFamilyPaymentRequestFromJSON(json: any): ReleaseFamilyPaymentRequest {
    return ReleaseFamilyPaymentRequestFromJSONTyped(json, false);
}

export function ReleaseFamilyPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseFamilyPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'userVaultId': ApiUserTasksGetPageParameterFromJSON(json['userVaultId']),
        'currency': json['currency'],
        'currencyDate': (new Date(json['currencyDate'])),
        'totalAmount': json['totalAmount'],
        'note': json['note'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function ReleaseFamilyPaymentRequestToJSON(json: any): ReleaseFamilyPaymentRequest {
    return ReleaseFamilyPaymentRequestToJSONTyped(json, false);
}

export function ReleaseFamilyPaymentRequestToJSONTyped(value?: ReleaseFamilyPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'userVaultId': ApiUserTasksGetPageParameterToJSON(value['userVaultId']),
        'currency': value['currency'],
        'currencyDate': value['currencyDate'].toISOString().substring(0,10),
        'totalAmount': value['totalAmount'],
        'note': value['note'],
        'origin': OriginToJSON(value['origin']),
    };
}

